import React, { useEffect, useState } from "react";
import { PAGE_TYPES } from "@sparefoot/tracking-events";
import { useExperimentLogging } from "@sparefoot/react-commons/hooks";

import { useSelector } from "react-redux";

import { Page } from "components/core/Page";
import { ScrollToTop } from "components/core/ScrollToTop";
import {
	ReviewsSection,
	StickySearchbar,
	StorageCompanyCount
} from "components/sdc/PaidLanding";
import ThreeSimpleStepsSection from "components/landing/ThreeSimpleStepsSection";

import usePageViewTracking from "hooks/tracking/usePageViewTracking";
import CLPHeroVariation from "components/clpHero/CLPHeroVariation";

function PaidLandingPage() {
	usePageViewTracking(PAGE_TYPES.PPC);
	useExperimentLogging("sf_14850_hero_promo_test_sdc");

	const [isCLPHeroVisible, setIsCLPHeroVisible] = useState(true);

	// Select the experiment variation from redux
	// sf_14850_hero_promo_test_sdc a/b test for hero promo
	const heroPromoExperimentVariation = useSelector(
		(state) => state.experiments?.bucket?.sf_14850_hero_promo_test_sdc
	);

	const handleScroll = () => {
		const clpHeroElement = document.getElementById("clp-hero");
		if (clpHeroElement) {
			const { bottom } = clpHeroElement.getBoundingClientRect();
			setIsCLPHeroVisible(bottom > 0);
		}
	};

	usePageViewTracking(PAGE_TYPES.PPC);

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	return (
		<Page
			className="paid-landing-page"
			pageType={PAGE_TYPES.PPC}
			title="Find the Cheapest Storage Units with Storage.com"
			description=""
		>
			<div className="main-container">
				<div id="clp-hero">
					<CLPHeroVariation
						heroPromoExperimentVariation={
							heroPromoExperimentVariation || "control"
						}
					/>
				</div>

				{!isCLPHeroVisible && <StickySearchbar />}
				<ThreeSimpleStepsSection />
				<ReviewsSection />
				<StorageCompanyCount />
			</div>
			<ScrollToTop />
		</Page>
	);
}

export default PaidLandingPage;
